import { createContext, useContext } from "react";

type DlContextValue = {
  gap: string;
  descriptionOffset: string;
};

const DEFAULT_DL_CONTEXT_VALUE: DlContextValue = {
  gap: "1rem",
  descriptionOffset: "1rem",
};

const DlContext = createContext<DlContextValue>(DEFAULT_DL_CONTEXT_VALUE);

function useDlContext() {
  return useContext(DlContext);
}

export { DEFAULT_DL_CONTEXT_VALUE, DlContext, useDlContext };
export type { DlContextValue };
